/** Session flag after successful admin login (#cup-data). */
export const CUP_ADMIN_SESSION_KEY = 'juniorCupScores.adminSession';

/**
 * Lozinka za admin (#cup-data).
 * Override in production: REACT_APP_CUP_ADMIN_PASSWORD in .env (never commit real secrets).
 */
export const CUP_ADMIN_PASSWORD =
  (process.env.REACT_APP_CUP_ADMIN_PASSWORD || '').trim() || '20godinakluba';
